import React, { useContext, useEffect, useState } from 'react';
import {
  DATA_CONFIGURATION,
  ADD_EDIT_RESPONSE_MESSAGES,
  LEAVE_UPLOAD,
} from '../../../Constants/strings';
import { MODULE_NAMES } from '../../../Constants/modules';
import dayjs from 'dayjs';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { AuthContext } from '../../../Contexts/AuthContext';
import UseAxios from '../../../Api/http/http';
import { STATUS_CODES } from '../../../Api/resources/statusCodes';
import { fetchConfigUploadDates, updateConfigUploadDates } from '../../../Api/request/configDataUploadDates';
import DataUploadConfig from '../../../Components/DataUploadConfig/dataUploadConfig';

const EffortUploadConfig = () => {
  const [effortEndError, setEffortEndError] = useState('');
  const [effortStartDate, setEffortStartDate] = useState('');
  const [effortIsChecked, setEffortIsChecked] = useState(false);
  const [effortStartError, setEffortStartError] = useState('');
  const [effortEndDate, setEffortEndDate] = useState('');
  const [effortIsEdit, setEffortIsEdit] = useState(false);
  const { snackbarOpen } = useSnackbar();
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.CONFIGURATION_DATE_CONFIG] || []
    : [];


  const fetchConfigEffortUploadDates = async () => {
    try {
      const uploadCategory = 'jira-work-log';
      const response = await UseAxios(fetchConfigUploadDates(uploadCategory));
      if (response.data?.response?.data?.statusCode === STATUS_CODES.NO_DATA) {
        console.log('No config Data');
      } else {
        const configDates = response.data.dataUploadConfig[0];
        setEffortStartDate(configDates.startDate);
        setEffortEndDate(configDates.endDate);
        setEffortIsChecked(configDates.isFutureEligibility);
      }
    } catch (error) {
      snackbarOpen(LEAVE_UPLOAD.OOPS_TRY_AGAIN, 'warning');
      console.error('Error fetching config effort upload dates:', error);
    }
  };

  const handleHasAccess = (action) => {
    return permission.includes(action);
  };

  useEffect(() => {
    fetchConfigEffortUploadDates();
  }, []);

  const handleEffortCheckBox = (event) => {
    setEffortIsChecked(event.target.checked);
  };

  const handleEffortEdit = () => {
    setEffortIsEdit(true);
  };
  const handleEffortValidateFields = (reqData) => {
    let isValid = true;

    if (!reqData.startDate) {
      setEffortStartError(ADD_EDIT_RESPONSE_MESSAGES.ENTER_START_DATE);
      isValid = false;
    } else {
      setEffortStartError('');
    }

    if (!reqData.endDate) {
      setEffortEndError(ADD_EDIT_RESPONSE_MESSAGES.ENTER_END_DATE);
      isValid = false;
    } else {
      setEffortEndError('');
    }

    return isValid;
  };

  const handleEffortEndDate = ({ value }) => {
    const formattedDate = dayjs(value).isValid()
      ? dayjs(value).format('YYYY-MM-DD')
      : '';
    setEffortEndDate(formattedDate);

    // Validate end date
    let endDateErrorMessage = '';
    const startDateErrorMessage = '';

    if (!formattedDate) {
      endDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.ENTER_END_DATE;
    } else if (
      effortStartDate && new Date(formattedDate) <= new Date(effortStartDate)
    ) {
      endDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.START_DATE_LESS_THAN_END_DATE;
    } else {
      setEffortStartError('');
      setEffortEndError('');
    }
    setEffortEndError(endDateErrorMessage);
    setEffortStartError(startDateErrorMessage);
  };

  const handleEffortStartDate = ({ value }) => {
    const formattedDate = dayjs(value).isValid()
      ? dayjs(value).format('YYYY-MM-DD')
      : '';
    setEffortStartDate(formattedDate);

    // Validate start date
    let startDateErrorMessage = '';
    const endDateErrorMessage = '';

    if (!formattedDate) {
      startDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.ENTER_START_DATE;
    } else if (
      effortEndDate && new Date(formattedDate) >= new Date(effortEndDate)
    ) {
      startDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.START_DATE_LESS_THAN_END_DATE;
    } else {
      setEffortStartError('');
      setEffortEndError('');
    }
    setEffortStartError(startDateErrorMessage);
    setEffortEndError(endDateErrorMessage);
  };


  const handleEffortSetButton = () => {
    try {

      if (effortStartError || effortEndError) return;

      const requestData = {
        startDate: effortStartDate,
        endDate: effortEndDate,
        isFutureEligibility: effortIsChecked,
        lastUpdatedBy: userProfile?.user_name,
        uploadCategory: 'jira-work-log',
      };

      if (!handleEffortValidateFields(requestData)) return;
      UseAxios(updateConfigUploadDates(requestData));
      setEffortIsEdit(false);
      snackbarOpen(DATA_CONFIGURATION.EFFORT_UPLOAD_ADD_SUCCESS,
        'success',
      );
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <DataUploadConfig
      isEdit={effortIsEdit}
      endDateInput={effortEndDate}
      header={DATA_CONFIGURATION.EFFORT_UPLOAD}
      startDateError={effortStartError}
      endDateError={effortEndError}
      startDateInput={effortStartDate}
      handleEdit={handleEffortEdit}
      isChecked={effortIsChecked}
      handleStartDate={handleEffortStartDate}
      hasAccess={handleHasAccess}
      handleSetButton={handleEffortSetButton}
      handleCheckBoxChange={handleEffortCheckBox}
      btnId='effort-upload-set-button'
      handleEndDate={handleEffortEndDate}
    />
  );
};

export default EffortUploadConfig;
